import { Button } from '../../Elements';
import { useFormContext } from '../Form';

type SubmitButtonProps = {
	children: string;
	isDisabled?: boolean;
	isLoading?: boolean;
	dataTestId?: string;
	allowDefaultValueSubmit?: boolean; // if true, allow form submission even if values are unchanged from default
};

export const SubmitButton = ({
	children,
	isDisabled,
	isLoading,
	dataTestId,
	allowDefaultValueSubmit = false,
}: SubmitButtonProps) => {
	const form = useFormContext();

	return (
		<form.Subscribe
			selector={(state) => ({
				canSubmit: state.canSubmit,
				isDefaultValue: state.isDefaultValue,
				isSubmitting: state.isSubmitting,
			})}
			children={({ canSubmit, isDefaultValue, isSubmitting }) => {
				return (
					<Button
						type='submit'
						disabled={
							!canSubmit || isDisabled || (!allowDefaultValueSubmit && isDefaultValue)
						}
						isLoading={isLoading || isSubmitting}
						dataTestId={dataTestId}
						size='lg'
					>
						{children}
					</Button>
				);
			}}
		></form.Subscribe>
	);
};
